import {
  UPDATE_SENTIMENT_REPORT,
  UPDATE_ACTIVE_DURATION,
  UPDATE_PRODUCT_SORTING,
  UPDATE_PLATFORMS,
  UPDATE_VIDEOS_SORTING,
  UPDATE_VIDEOS_SEARCH
} from "./SentimentReportAction";

const sentimentReportInitialState = {
  GenericStates: {
    tab: "overview",
  },
  SentimentByProduct: {},
  selectedDuration: {
    value: "1y",
    label: "",
  },
  productSortingOptions: [
    "highest_sentiment",
    "lowest_sentiment",
    "new_products",
    "highest_video_reviews",
  ],
  productsSortBy: "highest_sentiment",
  platformsOption: ["All"],
  videoSortingOptions: [
    "highest_sentiment",
    "lowest_sentiment",
    "newest_videos",
    "oldest_videos",
    "favorite_videos",
  ],
  videosSortBy: "highest_sentiment",
  search: "",
};

const sentimentReportReducer = (
  state = sentimentReportInitialState,
  action
) => {
  switch (action.type) {
    case UPDATE_SENTIMENT_REPORT:
      return {
        ...state,
        GenericStates: { ...state.GenericStates, ...action.data },
      };
    case UPDATE_ACTIVE_DURATION:
      return {
        ...state,
        selectedDuration: action.selectedDuration,
      };
    case UPDATE_PRODUCT_SORTING:
      return {
        ...state,
        productsSortBy: action.productsSortBy,
      };
    case UPDATE_VIDEOS_SORTING:
      return {
        ...state,
        videosSortBy: action.videosSortBy,
      };
    case UPDATE_VIDEOS_SEARCH:
      return {
        ...state,
        search: action.search,
      };
    case UPDATE_PLATFORMS:
      return {
        ...state,
        platformsOption: action.platformsOption,
      };
    default:
      return state;
  }
};

export default sentimentReportReducer;
